/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import { FC } from 'react'
import {
  DatePickerComponent,
  DateTimePickerComponent,
} from '@syncfusion/ej2-react-calendars'
import CN from 'classnames'

import './DateTimeRangePicker.scss'

export interface DateTimeRangePickerProps {
  endPlaceHolder?: string
  endValue?: any
  isErrored?: boolean
  onEndChange?: (e: any) => void | undefined
  onStartChange?: (e: any) => void | undefined
  startPlaceHolder?: string
  startValue?: any
  min?: Date
  [x: string]: any
}

export const DateTimeRangePicker: FC<DateTimeRangePickerProps> = ({
  endPlaceHolder,
  endValue,
  isErrored,
  onEndChange,
  onStartChange,
  startPlaceHolder,
  startValue,
  min,
  ...restProps
}: DateTimeRangePickerProps) => {
  return (
    <div
      className={CN('consign-date-time-picker', {
        '!outline-R-500 !outline-2': isErrored,
      })}>
      <DatePickerComponent
        id='datetimepicker'
        onChange={onStartChange}
        value={startValue}
        format={'yyyy/MM/dd'}
        strictMode={false}
        placeholder={startPlaceHolder}
        allowEdit={false}
        enabled
        min={min}
        //step={30}
      />

      <DatePickerComponent
        id='datetimepicker'
        onChange={onEndChange}
        format={'yyyy/MM/dd'}
        value={endValue}
        strictMode={false}
        placeholder={endPlaceHolder}
        allowEdit={false}
        enabled
        min={min}
        //step={30}
      />
    </div>
  )
}

DateTimeRangePicker.defaultProps = {
  endPlaceHolder: new Date().toLocaleDateString() + ' 12:00 AM',
  endValue: undefined,
  onEndChange: undefined,
  onStartChange: undefined,
  startPlaceHolder: new Date().toLocaleDateString() + ' 12:00 AM',
  startValue: undefined,
  isErrored: false,
}

export default DateTimeRangePicker
